import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js/instance/trim';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import React__default, { useState, useRef } from 'react';
import { api, login } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import img from '../../assets/account/password.svg.js';
import '@babel/runtime-corejs3/helpers/asyncToGenerator';
import '@babel/runtime-corejs3/regenerator';
import '@babel/runtime-corejs3/core-js/promise';
import '@babel/runtime-corejs3/core-js/instance/concat';
import 'lodash-es';
import '../components/types.js';
import { EAPIErrorCode } from '../../utils/fetcher.js';
import { prependPrefix } from '../../utils/style.js';
import '@babel/runtime-corejs3/core-js/reflect/construct';
import '@babel/runtime-corejs3/helpers/classCallCheck';
import '@babel/runtime-corejs3/helpers/createClass';
import '@babel/runtime-corejs3/helpers/inherits';
import '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import '@babel/runtime-corejs3/helpers/getPrototypeOf';
import { DEFAULT_REGION, FEEDBACK_URL } from '../utils/constants.js';
import { createFormToastToggler } from '../utils/toast.js';
import { validate } from '../utils/validate.js';
import '@babel/runtime-corejs3/helpers/assertThisInitialized';
import { ESendCodeType, ESendCodeMessageType } from '../api/captcha.js';
import { loginViaPassword } from '../api/password-login.js';
import 'qs';
import { toggleModal } from '../../modal/legacy-modal/index.js';
import { useGeetest } from '../../captcha/use-geetest.js';
import { Input, EInputType } from '../components/input/index.js';
import { LegacyPhoneInput } from '../components/phone-input/legacy-phone-input/index.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var FORM_CLASS = prependPrefix('legacy-password-login');
var toggleFormToast = createFormToastToggler(FORM_CLASS);
var LegacyPasswordLogin = function LegacyPasswordLogin(_ref) {
  var disabledCaptcha = _ref.disabledCaptcha,
      rememberMe = _ref.rememberMe,
      modal = _ref.modal,
      onRememberChange = _ref.onRememberChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      username = _useState4[0],
      setUsername = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      password = _useState6[0],
      setPassword = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      errs = _useState8[0],
      setErrs = _useState8[1];

  var _useState9 = useState(DEFAULT_REGION),
      _useState10 = _slicedToArray(_useState9, 2),
      region = _useState10[0],
      setRegion = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isEmail = _useState12[0],
      setIsEmail = _useState12[1];

  var _useGeetest = useGeetest({
    type: ESendCodeType.Login
  }),
      verify = _useGeetest.verify;

  var isVerifying = useRef(false);

  var handleCaptchaSuccess = function handleCaptchaSuccess(info) {
    setLoading(true);
    loginViaPassword(_objectSpread({
      region: region.code,
      login_name: username,
      password: password,
      remember_me: rememberMe ? 1 : 0
    }, (info === null || info === void 0 ? void 0 : info.captcha_token) && {
      captcha_token: info.captcha_token
    })).then(function () {
      if (!modal) {
        // 不在 Modal 中使用时，跳转到 backUrl 或首页
        window.location.href = login.getBackUrl();
        return;
      } // 在 Modal 中使用时，跳转到 backUrl 或刷新当前页面


      var backUrl = login.getBackUrl('');

      if (!backUrl) {
        window.location.reload();
        return;
      }

      window.location.href = backUrl;
    }).catch(function (err) {
      var _err$response;

      setLoading(false);

      if (!(err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && _err$response.info)) {
        toggleFormToast('登录失败，请重试');
        return;
      }

      var data = err.response; // 判断用户状态

      if (data.code === EAPIErrorCode.PopupModalRequired) {
        toggleModal({
          type: 'message',
          title: '登录失败',
          params: {
            messageText: data.message || (data.info[0] ? data.info[0].message : data.info),
            cancelText: '知道啦'
          }
        });
        return;
      }

      if (data.code === EAPIErrorCode.PromptFeedbackModal) {
        toggleModal({
          type: 'confirm',
          title: '登录失败',
          params: {
            messageText: data.message || data.info,
            cancelText: '我知道了',
            confirmText: '联系客服',
            onConfirm: function onConfirm() {
              return window.open(FEEDBACK_URL, '_blank');
            }
          }
        });
        return;
      }

      var errorInfo = err.response.info[0] || err.response.info;
      var error = {};

      switch (errorInfo.type) {
        case ESendCodeMessageType.ShowUnderAccount:
          error[isEmail ? 'email' : 'phone'] = errorInfo.message;
          break;

        case ESendCodeMessageType.ShowUnderPassword:
          error.password = errorInfo.message;
          break;

        case ESendCodeMessageType.ShowBothAccountPassword:
          error[isEmail ? 'email' : 'phone'] = errorInfo.message;
          error.password = errorInfo.message;
          break;

        default:
          toggleFormToast(errorInfo.message);
      }

      setErrs(error);
    });
  };

  var handleLoginTypeChange = function handleLoginTypeChange() {
    setLoading(false);
    setUsername('');
    setPassword('');
    setErrs({});
    setRegion(DEFAULT_REGION);
    setIsEmail(function (prev) {
      return !prev;
    });
  };

  var handleUsernameChange = function handleUsernameChange(e) {
    var value = e.target.value;

    if (!/^\d+$/.test(value) && value !== '') {
      return;
    }

    var newErrs = _objectSpread(_objectSpread({}, errs), {}, {
      phone: undefined
    });

    setUsername(value);
    setErrs(newErrs);
  };

  var handleEmailAddressChange = function handleEmailAddressChange(e) {
    var _context;

    var newErrs = errs;

    var value = _trimInstanceProperty(_context = e.target.value).call(_context);

    if (value) {
      newErrs = _objectSpread(_objectSpread({}, errs), {}, {
        email: undefined
      });
    }

    setUsername(value);
    setErrs(newErrs);
  };

  var handlePasswordChange = function handlePasswordChange(pwd) {
    var newErrs = errs;

    if (pwd) {
      newErrs = _objectSpread(_objectSpread({}, errs), {}, {
        password: undefined
      });
    }

    setPassword(pwd);
    setErrs(newErrs);
  };

  var handleRegionSelect = function handleRegionSelect(newRegion) {
    var newErrs = _objectSpread(_objectSpread({}, errs), {}, {
      phone: undefined
    });

    setRegion(newRegion);
    setErrs(newErrs);
  };

  var handleLoginSubmit = function handleLoginSubmit(e) {
    e.preventDefault();

    if (isVerifying.current || loading) {
      return;
    }

    var newErrs = validate(_defineProperty({
      password: password
    }, isEmail ? 'email' : 'phone', username));

    if (_Object$keys(newErrs).length) {
      setErrs(newErrs);
      return;
    } // 后端开启跳过验证时，不再传递 token 并直接登录


    if (disabledCaptcha) {
      handleCaptchaSuccess();
      return;
    }

    isVerifying.current = true; // geetest 验证

    verify().then(function (res) {
      if (res.success) {
        handleCaptchaSuccess(res);
      } else if (res.reason !== 'cancelled') {
        console.error(res.message || '未知错误');
      }
    }).finally(function () {
      isVerifying.current = false;
    });
  };

  return /*#__PURE__*/React__default.createElement("form", {
    className: prependPrefix('legacy-password-login'),
    onSubmit: handleLoginSubmit
  }, isEmail ? /*#__PURE__*/React__default.createElement("div", {
    className: classNames('email-input', {
      error: errs.email
    })
  }, /*#__PURE__*/React__default.createElement("i", null), /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    placeholder: "\u8BF7\u8F93\u5165\u90AE\u7BB1\u8D26\u53F7",
    value: username,
    onChange: handleEmailAddressChange
  }), errs.email && /*#__PURE__*/React__default.createElement("div", {
    className: "form-error-msg"
  }, errs.email)) : /*#__PURE__*/React__default.createElement(LegacyPhoneInput, {
    username: username,
    onRegionSelect: handleRegionSelect,
    onUsernameChange: handleUsernameChange,
    errorMsg: errs.phone
  }), /*#__PURE__*/React__default.createElement(Input, {
    className: "password-input",
    error: errs.password,
    type: EInputType.PASSWORD,
    value: password,
    onChange: handlePasswordChange,
    placeholder: "\u8BF7\u8F93\u5165\u5BC6\u7801",
    icon: img
  }), /*#__PURE__*/React__default.createElement("button", {
    type: "submit",
    className: classNames('login-btn', {
      loading: loading
    })
  }, !loading && '登录'), /*#__PURE__*/React__default.createElement("div", {
    className: "bottom-row"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "remember-me"
  }, /*#__PURE__*/React__default.createElement("input", {
    id: "remember-me-checkbox",
    type: "checkbox",
    checked: rememberMe,
    onChange: onRememberChange
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "remember-me-checkbox"
  }, "\u8BB0\u4F4F\u6211")), /*#__PURE__*/React__default.createElement("span", {
    className: "login-switch",
    onClick: handleLoginTypeChange
  }, isEmail ? '手机号密码登录' : '邮箱账号登录'), /*#__PURE__*/React__default.createElement("a", {
    className: "forget-passwd-btn",
    title: "\u5FD8\u8BB0\u5BC6\u7801\uFF1F",
    href: "".concat(api.MISSEVAN_SITE_MAIN, "/member/forgetpw")
  }, "\u5FD8\u8BB0\u5BC6\u7801")));
};

export { LegacyPasswordLogin };
